<template>
  <b-col
    v-show="mostarEspecialidades || mostarAdicionales"
    cols="12"
    class="mb-3 order-0 order-lg-1"
  >
    <dl
      class="row mb-0 border-top border-violeta-claro pt-3"
      id="masInformacion"
    >
      <dt
        v-show="mostarEspecialidades"
        class="col-5 col-lg-3 h6 text-morado-claro"
      >
        Especialidades
      </dt>
      <dd
        v-show="mostarEspecialidades"
        class="col-7 col-lg-9 font-weight-bold text-morado-claro pl-1"
      >
        {{ textoEspecialidades }}
      </dd>

      <dt
        v-show="mostarAdicionales"
        class="col-5 col-lg-3 h6 text-morado-claro"
      >
        Adicionales
      </dt>
      <dd v-show="mostarAdicionales" class="col-7 col-lg-9 text-azul pl-1">
        <li
          class="bulletless text-morado-claro font-weight-bold pr-1 mb-1"
          v-for="(ad, index) in adicionales"
          :key="index + '-adicionales-ficha'"
        >
          {{ ad }}
        </li>
      </dd>
    </dl>
  </b-col>
</template>

<script>
export default {
  props: {
    especialidades: {
      type: Array,
      required: true
    },
    adicionales: {
      type: Array,
      required: true
    }
  },
  computed: {
    //computa texto de especialidades
    textoEspecialidades() {
      let texto = "";
      let index = 0;
      for (let esp of this.especialidades) {
        index !== 0 ? (texto = texto + " - " + esp) : (texto = texto + esp);
        index++;
      }
      return texto;
    },
    //flag que me permite saber si debo mostar o no especialidades
    mostarEspecialidades() {
      return this.especialidades.length > 0 ? true : false;
    },
    //flag que me permite saber si debo mostar o no carac. adicionales
    mostarAdicionales() {
      return this.adicionales.length > 0 ? true : false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/izquierda/EspecialidadesYAdicionales.vue